import { range } from 'lodash-es'

import { S } from './@widgets/LectureGroup.style'

export const LectureListSkeleton = () => {
  return (
    <div css={S.LectureGroupList}>
      {range(0, 3).map((v) => (
        <div css={S.LectureGroup} key={v} />
      ))}
    </div>
  )
}
